import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import './index.css'



const TemplateWrapper = ({ children }) =>
  <div>
    <Helmet
      title="Moviepass Nearest Theaters"
      meta={[
        { name: 'description', content: 'Find nearest Moviepass Theaters using zip code' },
        { name: 'keywords', content: 'moviepass, mdudetm, reddit, nearest, theaters, zipcode, react' },
      ]}
    />
    <div
      style={{
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js